import usePrivateApi from '../../../../../hooks/usePrivateApi'
import Button from '../../../../../components/Button'
import Dialog from '../../../../../components/Dialog'

const UsersDisableModal = (props) => {
  const { dealerId, isOpen, setIsOpen, membership } = props

  const [{ isLoading, success, error }, { sendRequest }] = usePrivateApi()

  const handleSubmit = () => {
    sendRequest({
      url: `/admin/dealers/${dealerId}/users/${membership.id}`,
      method: 'patch',
      data: { status: 'DISABLED' },
    })
  }

  if (error) {
    return (
      <Dialog
        isOpen={isOpen}
        setIsOpen={() => window.location.reload()}
        title="An error occurred"
        buttonProps={null}
      >
        <p className="mt-2 text-gray-600 text-sm">
          Could not disable user account. Please try again later.
        </p>
        <Button className="mt-4" onClick={() => window.location.reload()}>
          Finish and close
        </Button>
      </Dialog>
    )
  }

  if (success) {
    return (
      <Dialog
        isOpen={isOpen}
        setIsOpen={() => window.location.reload()}
        title="Account disabled"
        buttonProps={null}
      >
        <p className="mt-2 text-gray-600 text-sm">
          Successfully disabled{' '}
          <strong>
            {membership.user.firstName} {membership.user.lastName}'s
          </strong>{' '}
          account ({membership.user.email}).
        </p>
        <Button className="mt-4" onClick={() => window.location.reload()}>
          Finish and close
        </Button>
      </Dialog>
    )
  }

  return (
    <Dialog
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(false)}
      title="Disable user account"
      buttonProps={{
        disabled: isLoading,
        children: isLoading ? 'Disabling...' : 'Disable account',
        onClick: handleSubmit,
        color: 'red',
      }}
    >
      <p className="mt-2 text-gray-600 text-sm">
        Are you sure you wish to disable{' '}
        <strong>
          {membership.user.firstName} {membership.user.lastName}'s
        </strong>{' '}
        account?
      </p>
      <p className="mt-2 text-gray-600 text-sm">
        This user won't be able to login or carry out any actions in the system
        once their account is disabled. You can re-activate their account in the
        future if required.
      </p>
    </Dialog>
  )
}

export default UsersDisableModal
